export default "__VITE_ASSET__CAnORom4__"